import React, {createContext, useReducer, useContext, Dispatch} from 'react';

export const ACTIONS = {
    /**
     * 设置骨架屏状态
     */
    SET_SKELETON_STATUS: 'setSkeletonStatus',

    /**
     * 设置弹窗moduleId
     */
    SET_DIALOG_STATUS: 'setDialogStatus',
};

export interface StoreState {
    displaySkeleton: boolean;
    dialogModuleId: number;
}

type ValueOf<T> = T[keyof T];

export interface StoreAction {
    type: ValueOf<typeof ACTIONS>;
    payload: any;
}

const initialState = {
    displaySkeleton: true,
    dialogModuleId: 0,
};

function reducer(state: StoreState, action: StoreAction) {
    switch (action.type) {
        case ACTIONS.SET_SKELETON_STATUS:
            state.displaySkeleton = action.payload;
            return {
                ...state,
            };
        case ACTIONS.SET_DIALOG_STATUS:
            state.dialogModuleId = action.payload;
            return {
                ...state,
            };
        default:
            console.error(`action type [${action.type}] 未找到`);
            return state;
    }
}

const StateContext = createContext<StoreState>(initialState);
export const DispatchContext = createContext<Dispatch<StoreAction> | null>(null);

function useStateStore() {
    return useContext(StateContext);
}

function useDispatchStore() {
    return useContext(DispatchContext);
}

const StoreProvider = React.memo(({children}) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    return (
        <StateContext.Provider value={state}>
            <DispatchContext.Provider value={dispatch}>
                {children}
            </DispatchContext.Provider>
        </StateContext.Provider>
    );
});

export {
    useStateStore,
    useDispatchStore,
    StoreProvider,
};
